import Flex from '~/common/components/Flex';
import MUICircularProgress from '~/common/components/Spinner/index';

const Spinner = () => (
  <Flex justifyContent="center" alignItems="center" height="656px">
    <MUICircularProgress size="xl" role="progressbar" />
  </Flex>
);

export default Spinner;
